export type RenderMetrics = {
  startedAt: number;
  dataFetchedAt: number | null;
  templateRenderedAt: number | null;
  iframeRenderedAt: number | null;
};

const elapsed = (from: number | null, to: number | null) =>
  from != null && to != null ? Math.round(to - from) : null;

export const buildRenderEventProperties = (
  metrics: RenderMetrics,
  swappedAt: number,
) => ({
  total_duration_ms: Math.round(swappedAt - metrics.startedAt),
  data_fetch_duration_ms: elapsed(metrics.startedAt, metrics.dataFetchedAt),
  template_render_duration_ms: elapsed(
    metrics.dataFetchedAt,
    metrics.templateRenderedAt,
  ),
  iframe_render_duration_ms: elapsed(
    metrics.templateRenderedAt,
    metrics.iframeRenderedAt,
  ),
  iframe_swap_duration_ms: elapsed(metrics.iframeRenderedAt, swappedAt),
});
